export const daycareLogin = 'https://app.trykidgenius.com/session/new';
export const register = 'https://app.trykidgenius.com/account/new';
export const demo = 'https://app.trykidgenius.com/login_demo';
